import { render, staticRenderFns } from "./ViqqaSendNote.vue?vue&type=template&id=4a1372d9"
import script from "./ViqqaSendNote.vue?vue&type=script&lang=js"
export * from "./ViqqaSendNote.vue?vue&type=script&lang=js"
import style0 from "./ViqqaSendNote.vue?vue&type=style&index=0&id=4a1372d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports